import { render } from "./BookingPopup.vue?vue&type=template&id=12d893ae"
import script from "./BookingPopup.vue?vue&type=script&lang=js"
export * from "./BookingPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__